import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-global-error__title" }
const _hoisted_2 = { class: "px-global-error__notice" }
const _hoisted_3 = {
  key: 1,
  class: "px-global-error__timeout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-no-time': _ctx.remainingTime === 0 }, "px-global-error"])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      alt: "Error Image",
      class: "px-global-error__icon",
      src: "/img/error.svg"
    }, null, -1)),
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("common.errors.global.title")), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.text || _ctx.$t("common.errors.global.notice")), 1),
    (_ctx.useAction)
      ? (_openBlock(), _createBlock(_component_PxButton, {
          key: 0,
          loading: _ctx.loading,
          class: "px-global-error__button",
          icon: "refresh",
          onClick: _ctx.dispatchActionEvent
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("common.errors.global.refreshButton")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.autoRefresh)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("common.errors.global.timeout", { seconds: _ctx.remainingTime })), 1))
      : _createCommentVNode("", true)
  ], 2))
}